import { z } from "zod";
import { LOCATION_TYPES, OWNERSHIP_TYPES } from "../enums.ts";
import { Address, DateOnly, Money } from "./common.ts";

export const FacilityInput = z.object({
  companyId: z.string().uuid(),
  name: z.string().min(1).max(200),
  /** facility | dairy_farm — a dairy farm is a location kind on the same record */
  locationKind: z.enum(["facility", "dairy_farm"]).default("facility"),
  address: Address.nullable().optional(),
  mashgiachPersonId: z.string().uuid().nullable().optional(),
  reportingRabbiPersonId: z.string().uuid().nullable().optional(),
  inspectionFrequency: z.string().max(60).nullable().optional(),
  mashgiachFee: Money.nullable().optional(),
  costPerInspection: Money.nullable().optional(),
  invoiceEnabled: z.boolean().default(true),
  sendInvoiceReminder: z.boolean().default(false),
  facilityLabel: z.string().max(120).nullable().optional(),
  usdaNumber: z.string().max(60).nullable().optional(),
  initialInspectionReport: z.boolean().default(false),
  facilityStart: DateOnly.nullable().optional(),
  facilityEnd: DateOnly.nullable().optional(),
  status: z.enum(["active", "pending", "seasonal", "inactive"]).default("active"),
  isHologramStorage: z.boolean().default(false),
  productionTypeIds: z.array(z.string().uuid()).default([]),
  notes: z.string().max(4000).nullable().optional(),
});
export type FacilityInput = z.infer<typeof FacilityInput>;
export const FacilityUpdateInput = FacilityInput.partial().omit({ companyId: true });

export const PlantInput = z.object({
  name: z.string().min(1).max(200),
  address: Address.nullable().optional(),
  primaryContact: z.string().max(300).nullable().optional(),
  secondaryContact: z.string().max(300).nullable().optional(),
  adminRcPersonId: z.string().uuid().nullable().optional(),
  reportingRabbiPersonId: z.string().uuid().nullable().optional(),
  inspectionFrequency: z.string().max(60).nullable().optional(),
  initialInspectionReport: z.boolean().default(false),
  isHologramStorage: z.boolean().default(false),
  status: z.enum(["active", "pending", "inactive"]).default("active"),
  productionTypeIds: z.array(z.string().uuid()).default([]),
  notes: z.string().max(4000).nullable().optional(),
});
export type PlantInput = z.infer<typeof PlantInput>;
export const PlantUpdateInput = PlantInput.partial();

export const CompanyPlantLinkInput = z.object({
  companyId: z.string().uuid(),
  plantId: z.string().uuid(),
  ownershipType: z.enum(OWNERSHIP_TYPES).default("MFG"),
  linkStatus: z.enum(["pending", "linked", "ended"]).default("pending"),
});

export const LocationQuery = z.object({
  q: z.string().max(200).optional(),
  companyId: z.string().uuid().optional(),
  status: z.string().max(40).optional(),
  mine: z
    .string()
    .optional()
    .transform((v) => v === "1" || v === "true"),
});

export const LocationRef = z.object({
  locationType: z.enum(LOCATION_TYPES),
  locationId: z.string().uuid(),
});
export type LocationRef = z.infer<typeof LocationRef>;
